import React, { useState } from 'react';
import NearbyStopPage from './components/pages/NearbyStopPage';
import TopBar from './components/TopBar';
import MapPage from './components/pages/MapPage';

function App() {
  const [currentPage, setCurrentPage] = useState('Home');

  return (
    <div>
      <TopBar currentPage={currentPage} setCurrentPage={setCurrentPage} />

      {currentPage === 'Home' && <NearbyStopPage />}
      {currentPage === 'Map' && <MapPage />}
    </div>
  );
}

export default App;
